<template>
    <v-dialog
        content-class="border-radius-1 pt-0"
        v-model="dialog"
        persistent
        max-width="610"
        :retain-focus="false"
        overlay-color="primary"
        overlay-opacity="0.95"
    >
        <v-card v-resize="onResize" style="background: white;">
            <v-card-title class="pt-2 px-10">
                <v-row justify="center" justify-md="space-between">
                    <v-col cols="12">
                        <v-btn
                            color="#EEECF880"
                            class="no-uppercase text-body-1 neutral--text my-2 my-md-0 mx-sm-2 mx-md-0"
                            block
                            height="60"
                            elevation="0"
                            @click="closeModal"
                        >
                            <v-icon class="mr-2">mdi-undo-variant</v-icon>
                            {{ backText }}
                        </v-btn>
                    </v-col>
                    <v-col
                        cols="12"
                        class=""
                    >
                        <v-row align="center" justify="center">
                            <div class="chip-wrap position-relative">
                            <v-img
                                :src="require('@/assets/img/gamifications/tag--tienes.png')"
                                height="36"
                                width="80"
                                contain
                                class="coin-tag"
                                ></v-img>
                            <div class="coin-chip">
                                <v-img
                                    :src="require('@/assets/img/icons/beecoins.png')"
                                    height="32"
                                    width="32"
                                ></v-img>
                                <span>{{ userData.coins }}</span>
                            </div>
                        </div>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-title>
                <template v-if="buyData.value">
                    <v-row justify="center" class="mx-0 px-0 pb-0" v-if="buyData.isAvatar">
                        <v-img
                            :src="`https://assets.beereaders.com/avatar/${buyData.value.name}/${buyData.value.value}`"
                            :height="imgSize"
                            :max-width="imgSize"
                            class="ma-2 skin-img"
                        />
                    </v-row>
                    <v-row justify="center" class="mx-0 px-0 py-6" v-if="buyData.isSkin">
                        <v-img
                            :src="`https://assets.beereaders.com/skins/${getThumbnail(buyData.value)}`"
                            :height="imgSize/1.5"
                            :max-width="imgSize/1.5"
                            class="ma-2 skin-img"
                        />
                    </v-row>
                </template>
                
            <v-card-text class="mt-4">
                <v-row>
                    <v-col cols="12" sm="10" offset-sm="1" class="item-description">
                        <span class="text-h5">
                            {{ elementText }}
                        </span>
                        <p 
                            class="px-12 mt-4 mb-0 text-body-1 line-height-130"
                            v-html="descriptionText">
                        </p>
                        
                        <v-row class="coins-card mx-2 mt-3">
                            <v-col cols="4" offset="2" class="pr-0 pt-0 position-relative" justify="end">
                                <v-img
                                    :src="require('@/assets/img/icons/beecoins.png')"
                                    height="70"
                                    width="70"
                                    contain
                                    class="coin-img"
                                    >
                                </v-img>
                            </v-col>
                            <v-col class="d-flex flex-column justify-content-center text-start pl-0 py-0">
                                <p class="text-h5 mb-0 font-weight-black line-height-100" v-if="buyData.isAvatar">
                                    {{ buyData.value.avatarPack.price }}
                                </p>
                                <p class="text-h5 mb-0 font-weight-black line-height-100" v-if="buyData.isSkin">
                                    {{ buyData.value.price }}
                                </p>
                                <p class="mb-0">BeeCoins</p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-row class="ma-0">
                    <v-col
                        class="pt-0"
                        cols="12">
                        <v-btn
                            data-cy="buy-btn-profile"
                            class="buy-btn"
                            fab
                            dark
                            large
                            color="primary"
                            depressed
                            @click="toBuy"
                            :loading="btnLoading"
                            :disabled="userData.coins<price"
                            
                        >
                            <v-img
                            contain
                            height="32"
                            width="32"
                            :src="require('@/assets/img/icons/store/icon-buy-shadow.png')"
                            ></v-img>
                        </v-btn>
                        <br>
                        <strong class="buy-text-btn"><small class="text-primary text-nowrap">
                            {{ $t('store.buy') }}
                        </small></strong>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import GamificationService from '../../services/gamification'
import PurchaseService from '../../services/purchase'

const defaultData = {
    isAvatar: false,
    isSkin: false,
    value: null
}

export default {
    props: {
        buyData: { type: Object, default: defaultData },
        dialog: { type: Boolean, default: false }
    },
    data() {
        return {
            btnLoading: false,
            imgSize: 300,
            reload: 0,
            selectedSkin: {},
            priceIconSize: 300,
            windowSize: {
                x: 0,
                y: 0
            }
        }
    },
    mounted() {
        this.onResize()
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            userData: (state) => state.userData
        }),
        backText() {
            return this.buyData.isAvatar ? this.$t('profile.back_to_avatars') : this.$t('profile.back_to_skins')
        },
        elementText() {
            return this.buyData.isAvatar ? this.$t('profile.special_avatar') : this.$t('profile.special_skin')
        },
        descriptionText() {
            return this.buyData.isAvatar ? this.$t('profile.purchase_avatar_desc') : this.$t('profile.purchase_skin_desc')
        },
        buyText() {
            return this.buyData.isAvatar ? this.$t('profile.buy_this_avatar') : this.$t('profile.buy_this_skin')
        },
        price() {
            if (this.buyData.isAvatar) {
                return this.buyData.value.avatarPack.price
            }
            return this.buyData.isSkin ? this.buyData.value.price : 0
        }
    },
    methods: {
        ...mapActions('userData', [
            'setGamification',
        ]),
        closeModal () {
            this.$emit('close')
        },
        async getGamification () {
            GamificationService.getUserGameStatsByUser(
                this.user.id
            )
            .then((response) => {
                if (response.content.id) {
                    this.setGamification(response.content)
                }
            })
            .catch((error) => console.error(error))
        },
        getThumbnail(skin) {
            const img = skin.resources.find((res) => res.resourceUrl.includes('thumbnail'))
            return img.resourceUrl
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if (this.windowSize.y < 670) {
                this.imgSize = 80
                this.priceIconSize = 60
                return
            }
            if (this.windowSize.y < 725) {
                this.imgSize = 130
                this.priceIconSize = 60
                return
            }
            if (this.windowSize.y < 835) {
                this.imgSize = 180
                this.priceIconSize = 60
                return
            }
            this.imgSize = 180
            this.priceIconSize = 280
        },
        async toBuy () {
            this.btnLoading = true
            if (this.buyData.isAvatar) {
                await PurchaseService.createPurchaseAvatarPack(
                    this.user.id,
                    this.buyData.value.avatarPack.id
                )
                .catch((error) => console.error(error))
                this.btnLoading = false
            } else {
                await PurchaseService.createPurchaseSkin(
                    this.user.id,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            await this.getGamification()
            this.btnLoading = false
            this.closeModal()
        }
    }
}
</script>

<style lang="scss" scoped>
.color-primary {
    color: #514773;
}
.color-text {
    color: #4A3216;
}
.color-price {
    color: #DF820D;
}
.coins {
    margin-top: -5px;
}
.price-avatar {
    margin-top: 180px;
}
.price-skin {
    margin-top: 60px;
}
.text-price {
    font-size: .75rem;
    margin-top: 15px;
}
.text-beecoins {
    font-size: .65rem;
    margin-top: -10px;
}

@media (min-height: 500px) {
    .price-avatar {
        margin-top: 50px;
    }
    .price-skin {
        margin-top: 60px;
    }
    .text-price {
        font-size: .75rem;
        margin-top: 10px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -5px;
    }
}
@media (min-height: 670px) {
    .price-avatar {
        margin-top: 80px;
    }
    .price-skin {
        margin-top: 90px;
    }
    .text-price {
        font-size: .75rem;
        margin-top: 10px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -5px;
    }
}
@media (min-height: 725px) {
    .price-avatar {
        margin-top: 130px;
    }
    .price-skin {
        margin-top: 120px;
    }
    .text-price {
        font-size: .9rem;
        margin-top: 15px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -8px;
    }
}
@media (min-height: 835px) {
    .price-avatar {
        margin-top: 170px;
    }
    .price-skin {
        margin-top: 150px;
    }
    .text-price {
        font-size: 1.25rem;
        margin-top: 30px;
    }
    .text-beecoins {
        font-size: 1rem;
        margin-top: 0px;
    }
}

.no-uppercase {
     text-transform: none;
}
.skin-img {
    display: block;
    width: 100%;
    border-radius: 20px;
}
.coin-chip{
    align-items: center;
    background: #EEECF8;
    border-radius: 8px;
    color: #323A46;
    display: inline-flex;
    font-size: 1rem;
    font-weight: 700;
    margin-right: 15px;
    padding: 8px 12px;
    .v-image{
        display: inline-flex;
    }
}
.coin-tag{
    display: inline-flex;
    right: -15px;
    position: relative;
    top: 3px;
}
.neutral--text{
    color: #323A46;
    font-weight: 500;
}
.item-description{
    background: #EEECF880;
    border-radius: 8px;
    color: #323A46;
    padding: 1rem;
    span{
        font-weight: 600;
    }
}
.coins-card{
    background: #EEECF8;
    border-radius: 8px;
    color: #323A46;
    padding: 1rem;
    .coin-img{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}
.buy-btn{
    background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
    box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 24px 0px #7764CA66;
    &.v-btn.v-btn--disabled{
        opacity: .5!important;
    }
}
.buy-text-btn{
    color: #7764CA;
    font-weight: 600;
}
</style>